<template>
    <page>
        <module v-if="!auth('b_home_work')" enable-flex>
            <div class="empty flex-grow flex-center">
                <img src="@/assets/image/home.png" alt="">
            </div>
        </module>
        <module v-else :drag="false" gap="12">
            <module-row size="auto" v-if="canShowSummary">
                <module-col title="工作数据简报">
                    <template #head>
                        <div class="module-head flex-end-center">
                            <div class="flex-center head-handle">
                                <c-tab-list :tabs="timeTab" type="card" @change="updatePerformance"></c-tab-list>
                            </div>
                        </div>
                    </template>

                    <ul class="performance-list flex-wrap">
                        <li v-for="(item, i) in performanceList" :key="i" class="flex-column flex-center">
                            <div class="data" :style="{'color': item.color}">
                                {{item.value}}<span>{{item.unit || ''}}</span>
                            </div>
                            <div class="flex-center">
                                <p>{{item.name}}</p>
                                <c-tooltip v-if="item.tip" :tip="item.tip" width="150" position="top"></c-tooltip>
                            </div>
                        </li>
                    </ul>
                </module-col>

            </module-row>

            <module-row size="auto">
                <module-col title="待办事项">
                    <div class="backlog flex-wrap">
                        <div v-for="(item, i) in stayDataList" :key="i" class="item-box">
                            <!-- <div class="item" v-if="power(item.unique_key)" @click="navigateTo(item.to_page);"> -->
                            <div class="item" @click="navigateTo({name:item.key});">
                                <div>{{item.value}}</div>
                                <label>{{item.name}}</label>
                            </div>
                        </div>
                    </div>
                </module-col>
                <module-col title="常用功能">
                    <div class="history flex-wrap">
                        <div v-for="(item, i) in commonFunList" :key="i" class="item-box">
                            <div class="item" @click="navigateTo({name:item.key});">{{item.name}}</div>
                        </div>
                    </div>
                </module-col>
            </module-row>

            <module-row size="auto" title="售后申请单" v-if="hasApplyAuth">
                <template #head>
                    <div class="module-head flex-end-center">
                        <div class="flex-center head-handle">
                            <c-tab-list :tabs="applyTab" type="card" @change="updateApplyOrder"></c-tab-list>
                        </div>
                    </div>
                </template>
                <c-table ref="workList" height="505" width-resize :paging="{size: 10, select: false}" @widthResize="widthResizeHandle">
                    <template v-for="(col, i) in applyField">
                        <c-table-column
                                v-if="col.is_display == 1 && !(col.field_code == 'service_progress' && currentApplyTab == 0)"
                                :key="col.field_code"
                                :label="col.field_title"
                                :name="col.field_code"
                                :width="col.width"
                                :fixed="col.is_lock == 1 ? 'left' : false"
                        >
                            <!--单据编号-->
                            <template v-if="col.field_code == 'aftersale_apply_no'" #default="{data}">
                                <c-link @click="globalDialog('aftersaleApplyDetail', {props: {id: data.id}})">{{data.aftersale_apply_no}}</c-link>
                                <c-state v-if="data.tags && data.tags.indexOf('测试')!=-1" dict="applyTagShortDic" tag value="测"></c-state>
                            </template>
                            <!--转单状态-->
							<template v-else-if="col.field_code == 'order_transfer_status'" #default="{data}">
                                <c-state dict="orderTransferStatusDic" :value="data.order_transfer_status"></c-state>
							</template>
                            <!--单据进度-->
							<template v-else-if="col.field_code == 'service_progress'" #default="{data}">
                                <c-steps v-if="data.order_transfer_status == 1 && data.service_progress" :steps="serviceProgressDic" :active="data.service_progress" gap="50" style="padding: 0;"></c-steps>
                                <span v-else>-</span>
							</template>
                            <!--服务类型-->
                            <template v-else-if="col.field_code == 'service_type_code'" #default="{data}">
                                <c-state dict="serviceTypeDic" tag :value="data.service_type_code"></c-state>
                            </template>
                            <!--售后类型-->
                            <template v-else-if="col.field_code == 'aftersale_type_code'" #default="{data}">
                                <c-state dict="afterSaleTypeDic" tag :value="data.aftersale_type_code"></c-state>
                            </template>
                            <!--是否收费-->
                            <template v-else-if="col.field_code == 'is_charge_code'" #default="{data}">
                                <c-state dict="isChargeDic" tag :value="data.is_charge_code"></c-state>
                            </template>
                            <!--金额-->
							<template v-else-if="col.field_code == 'estimated_fee'" #default="{data}">
                                ￥{{data.estimated_fee}}
							</template>
                        </c-table-column>
                    </template>

                    <c-table-column
                            type="button"
                            label="操作"
                            width="125"
                            button-limit="4"
                    >
                        <template #default="{data}">
                            <c-table-button icon="tf-detail" @click="globalDialog('aftersaleApplyDetail', {props: {id: data.id}})">查看</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </module-row>
        </module>
    </page>
</template>

<script>
import pie from './components/pie.vue'
import flowProduce from './components/flow_produce.vue'
import flowStorage from './components/flow_storage.vue'
import {mapState} from "vuex";

export default {
    name: 'home',

    components: {
        pie,
        flowProduce,
        flowStorage
    },

    props: {
        type: String
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['orderTransferStatusDic','afterSaleTypeDic','serviceTypeDic','applyTagDic','applyTagShortDic','serviceProgressDic','userInfo']),

        // 是否有售后申请单相关权限
        hasApplyAuth() {
            return this.auth('m_aftersale_apply');
        },

        // 是否有售后工单相关权限
        hasOrderAuth() {
            return this.auth('m_aftersale_order');
        },

        // 是否能看到工作数据简报（有申请单或工单权限即可）
        canShowSummary() {
            return this.hasApplyAuth || this.hasOrderAuth;
        }
    },

    data() {
        return {
            unstartProcess: false,
            timeTab: [],
            currentProcessTab: {},
            processList: [],
            moreProcess: false,
            processFold: true,
            performanceList: [],
            applyTab: [{
                name: '待转单',
                value: 0
            },
            {
                name: '已挂起',
                value: 2
            },
                {
                name: '已转单',
                value: 1
            }],
            applyField: [],
            viewId:1,
            stayDataList: [],       //常用功能
            commonFunList: [],       //代办事项
            currentApplyTab: 0
        }
    },

    watch: {
        unstartProcess() {
            this.updateProcess();
        }
    },

    mounted() {
        this.request({
            url: '/time/type',
            data: {
                type: 2
            },
            success: data => {
                this.timeTab = data.map(item => {
                    return {
                        name: item.name,
                        value: item.time_type
                    }
                });
            }
        });

        this.updateapplyField();

        this.getStayItems();

        this.getCommonFun();

        window.addEventListener('resize', this.resize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    },

    methods: {
        updatePerformance(tab) {
            let requestData = {
                time_type: tab.value
            };
            // 用户有网点关联则只查自己网点的数据
            if (this.userInfo && this.userInfo.outlet_id) {
                requestData.outlet_id = this.userInfo.outlet_id;
            }
            this.request({
                url: '/home/summary',
                data: requestData,
                success: data => {
                    this.performanceList = [
                    {
                        name: '售后申请单',
                        code: 'aftersale_apply_count',
                        tip:'新增的售后申请单总数'
                    }, {
                        name: '待处理申请单',
                        code: 'pending_apply_count',
                        tip:'等待转成工单的申请单数量'
                    }, {
                        name: '新增工单',
                        code: 'new_order_count',
                        tip:'新建的工单数量'
                    }, {
                        name: '待派工单数',
                        code: 'pending_receive_order_count',
                        color: '#00B38A',
                        tip:'已创建但还未分配人员的工单'
                    },{
                        name: '未完成工单',
                        code: 'unfinished_order_count',
                        tip:'客户还未验收的工单总数'
                    }, {
                        name: '已完成工单',
                        code: 'finished_order_count',
                        tip:'客户已验收完成的工单总数'
                    }, {
                        name: '加急工单',
                        code: 'urgent_order_count',
                        tip:'标记为紧急处理的工单'
                    }, {
                        name: '逾期工单',
                        code: 'overdue_order_count',
                        tip:'超过预约时间仍未开始的工单'
                    }, {
                        name: '派工次数',
                        code: 'dispatch_person_times',
                        color: '#FF8A00',
                        tip:'总共派单次数'
                    }, {
                        name: '自动派单占比',
                        code: 'auto_dispatch_ratio',
                        unit: '%',
                        tip:'自动派单占所有派单的比例'
                    }, {
                        name: '申请单平均转单时长',
                        code: 'avg_transfer_duration_days',
                        unit: '天',
                        tip:'从申请单到创建工单的平均用时'
                    }, {
                        name: '工单平均确认时长',
                        code: 'avg_confirm_duration_hours',
                        unit: '小时',
                        tip:'从派单到负责人确认的平均用时'
                    },{
                        name: '工单平均处理时长',
                        code: 'avg_process_duration_days',
                        unit: '天',
                        tip:'完工工单从开始到完成的平均用时'
                    }].filter(item => {
                        // 根据权限过滤指标项
                        if (['aftersale_apply_count', 'pending_apply_count'].includes(item.code)) {
                            return this.hasApplyAuth;
                        }
                        return this.hasOrderAuth;
                    }).map(item => {
                        item.value = data[item.code] || 0;
                        return item;
                    });
                }
            });
        },

        updateDefects(tab) {
            this.request({
                url: '/home/defects/distribution',
                data: {
                    time_type: tab.value
                },
                success: data => {
                    this.$refs.pie && this.$refs.pie.update(data.map(item => {
                        return {
                            name: item.defects_name,
                            value: item.count
                        }
                    }));
                }
            });
        },

        updateapplyField() {
            this.request({
                url: '/sys_user_view/list',
                data: {
                    work_type_id: 1
                },
                success: data => {
                    if (data && data.length > 0){
                        this.viewId = data[0].id;
                        this.request({
                            url: '/sys_user_view/config',
                            data: {
                                view_id: this.viewId
                            },
                            success: data => {
                                this.applyField = [];
                                this.$nextTick(() => {
                                    this.applyField = data.field_list;
                                });
                            }
                        });
                    }
                }
            });
        },

        updateApplyOrder(tab) {
            this.currentApplyTab = tab.value;
            let requestData = {
                view_id: this.viewId,
                pageSize: 10,
                order_transfer_status: [tab.value],
                outlet_auth_filter: '1'
            };
            this.$refs.workList.load({
                url: '/aftersale/apply/list',
                data: requestData,
                success: () => {
                    this.resize();
                }
            });
        },

        resize() {
            this.$nextTick(() => {
                if (this.$refs.processList) {
                    this.moreProcess = this.$refs.processList.offsetHeight > 120;
                } else {
                    this.moreProcess = false;
                }
                this.$refs.pie && this.$refs.pie.resize();
            });
        },

        widthResizeHandle(col) {
            let item = this.applyField.find(item => item.field_code == col.name);
            if (item) {
                item.width = col.width;
                this.request({
                    url: '/sys_user_view/edit_field',
                    data: {
                        view_id: 10010,
                        field_list: this.applyField.map(item => {
                            return {
                                field_id: item.field_id,
                                width: item.width,
                                is_display: item.is_display,
                                is_lock: item.is_lock
                            }
                        })
                    }
                })
            }
        },

        // 待办事项
        getStayItems() {
            let requestData = {};
            // 用户有网点关联则只查自己网点的数据
            if (this.userInfo && this.userInfo.outlet_id) {
                requestData.outlet_id = this.userInfo.outlet_id;
            }
            this.request({
                url: '/home/stayItem',
                data: requestData,
                success: data => {
                    this.stayDataList = data;
                }
            });
        },
        // 常用功能
        getCommonFun() {
            this.request({
                url: '/home/common_func',
                success: data => {
                    this.commonFunList = data;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
>>> .c-module-head {
    height: 56px;
    border: none;

    .c-module-title {
        line-height: 56px;
    }
}

>>> .c-tab-list {
    ul {
        padding: 0;

        li {
            height: 28px;
        }
    }
}

.empty {
    img {
        width: 575px;
    }
}

.module-head {
    height: 100%;
    padding: 0 20px 0 12px;

    >>> .c-link {
        box-sizing: border-box;
        width: 28px;
        height: 28px;
        border: 1px solid #ddd;
        margin-right: 6px;

        &:hover {
            border-color: var(--color-main);
            color: #fff !important;
            background: var(--color-main);
        }
    }

    .head-handle {
        gap: 12px;
    }
}

.process {
    &-list {
        margin: 10px 20px;
        overflow: hidden;

        ul {
            gap: 14px;
            min-height: 120px;
        }

        li {
            position: relative;
            width: calc(16.6666% - 12px);
            height: 120px;
            background: #F9F9F9;

            @media screen and (max-width: 1699px) {
                width: calc(20% - 12px);
            }

            @media screen and (max-width: 1399px) {
                width: calc(25% - 12px);
            }

            @media screen and (max-width: 1199px) {
                width: calc(33.3333% - 12px);
            }

            label {
                position: absolute;
                left: 0;
                top: 0;
                padding: 0 8px;
                line-height: 22px;
                font-size: 13px;
                color: #006FF3;
                background: #E9F4FF;
            }

            .count {
                gap: 8px;
                padding-top: 10px;
                font-size: 12px;
                color: #999;

                div {
                    font-size: 30px;
                }
            }

            .info {
                width: 105px;
                line-height: 24px;
                font-size: 12px;
                color: #999;
            }

            .rate {
                height: 28px;
                border-top: 1px solid #eee;
                padding: 0 10px;

                p {
                    margin-right: 6px;
                    font-size: 12px;
                    color: #999;
                }
            }
        }
    }

    &-more {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%,0);
        width: 54px;
        height: 27px;
        padding: 10px 10px 0;
        overflow: hidden;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            left: 10px;
            top: 10px;
            width: 54px;
            height: 54px;
            border-radius: 27px;
            background: #fff;
            box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
        }

        .tf {
            position: relative;
            font-size: 10px;
            color: var(--color-main);
        }
    }
}

.performance {
    &-list {
        gap: 12px;
        min-height: 120px;
        padding: 10px 20px 20px;

        li {
            position: relative;
            width: calc(20% - 10px);
            height: 100px;
            background: #F9F9F9;

            @media screen and (max-width: 1199px) {
                width: calc(25% - 9px);
            }

            .data {
                margin-bottom: 10px;
                font-size: 26px;

                span {
                    margin-left: 2px;
                    font-size: 15px;
                }
            }

            p {
                font-size: 13px;
                color: #999;

                &:nth-last-child(2) {
                    margin-right: 6px;
                }
            }
        }
    }
}

.backlog {
    margin: 0 0 18px 18px;

    .item {
        padding: 16px 0 14px;
        text-align: center;
        background: #F9F9F9;
        cursor: pointer;

        &:hover {
            background: var(--color-main);

            div,
            label {
                color: #fff;
            }
        }

        &-box {
            box-sizing: border-box;
            width: 25%;
            padding-right: 10px;
            padding-top: 10px;
            @media screen and (max-width: 1500px) {
                & {
                    width: 33.333%;
                }
            }
            @media screen and (max-width: 1100px) {
                & {
                    width: 50%;
                }
            }
            @media screen and (max-width: 900px) {
                & {
                    width: 100%;
                }
            }
        }

        div {
            margin-bottom: 5px;
            font-size: 30px;
            font-weight: bold;
        }

        label {
            font-size: 13px;
            color: #666;
        }
    }
}

.history {
    margin: 0 0 14px 14px;

    .item {
        border: 1px solid #eee;
        line-height: 42px;
        font-size: 14px;
        text-align: center;
        color: #333;
        cursor: pointer;

        &:hover {
            border-color: var(--color-main);
            font-weight: bold;
            color: var(--color-main);
        }

        &-box {
            box-sizing: border-box;
            width: 16.6666%;
            padding-right: 14px;
            padding-top: 14px;

            @media screen and (max-width: 1800px) {
                & {
                    width: 20%;
                }
            }
            @media screen and (max-width: 1600px) {
                & {
                    width: 25%;
                }
            }
            @media screen and (max-width: 1300px) {
                & {
                    width: 33.3333%;
                }
            }
            @media screen and (max-width: 1000px) {
                & {
                    width: 50%;
                }
            }
            @media screen and (max-width: 700px) {
                & {
                    width: 100%;
                }
            }
        }
    }
}
</style>